var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.6538 9H11.3462C10.3266 9 9.5 9.82655 9.5 10.8462V19.1538C9.5 20.1734 10.3266 21 11.3462 21H19.6538C20.6734 21 21.5 20.1734 21.5 19.1538V10.8462C21.5 9.82655 20.6734 9 19.6538 9Z",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26923 15H5.34615C4.85652 15 4.38695 14.8055 4.04073 14.4593C3.6945 14.1131 3.5 13.6435 3.5 13.1538V4.84615C3.5 4.35652 3.6945 3.88695 4.04073 3.54073C4.38695 3.1945 4.85652 3 5.34615 3H13.6538C14.1435 3 14.6131 3.1945 14.9593 3.54073C15.3055 3.88695 15.5 4.35652 15.5 4.84615V5.76923",
    stroke: "#4F4F4F",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.b75130bc6463c4f814bbba9ca19b7dfe.svg";
export { ForwardRef as ReactComponent };